<div class="layout-footer">
  <!-- Copyright -->
  <a class="mr-2">
    <img class="rounded-md w-24 h-auto boost-logo" src="assets/images/boost.png" />
  </a>
  <span>All Rights Reserved</span>
</div>
